import About from '../pages/About';
import CRM from '../pages/CRM';
import Edit from '../pages/Edit';
import Graphics from '../pages/Graphics';
import IAM from '../pages/IAM';
import Permissions from '../pages/Permissions';

const PAGE_CONFIG = [
  {
    name: 'עמוד הבית',
    renderComponent: (props) => <Edit {...props} />,
  },
  {
    name: 'הרשאות',
    renderComponent: (props) => <Permissions {...props} />,
  },
  // {
  //     name: "CRM",
  //     renderComponent: (props) => <CRM {...props} />
  // },
  {
    name: 'IAM',
    renderComponent: (props) => <IAM {...props} />,
  },
  {
    name: 'גרפיקה',
    renderComponent: (props) => <Graphics {...props} />,
  },
  {
    name: 'אודות',
    renderComponent: (props) => <About {...props} />,
  },
];

export { PAGE_CONFIG };
